import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";
import ScrollToTop from "./components/scrollToTop";
import MobileBurgerMenu from "./components/mobileBurgerMenu";
import loadGame from "./components/loadGame";
import PerfectScrollbarInit from "./components/PerfectScrollbar";
import Faq from "./components/faq_block";
import tocHiddeSubItems from "./components/tocHiddeSubItems";
import tocCustomizeWrapper from "./components/tocCustomizeWrapper";

document.addEventListener( 'DOMContentLoaded', function () {

	lazyLoad();

	let myLazyLoad = new LazyLoad();

	ScrollToTop();

	MobileBurgerMenu();

	// customise table scroll line
	PerfectScrollbarInit();

	// iframe on click
	loadGame();

	// faq
	Faq();

	// toc hide menu subitems
	tocHiddeSubItems();

	// toc hide menu subitems
	tocCustomizeWrapper();
} );